<template>

    <div class="parent-container">
        <div class="container-loading">
            <div class="spinner-wrapper">
                <!-- <Dots></Dots> -->
                <ion-spinner :color="color" name="circular"></ion-spinner>
            </div>
            <ion-text :color="color" class="loading-text">
                <p>Een moment geduld...</p>
            </ion-text>
        </div>
    </div>

</template>
<script>
import { IonSpinner, IonText } from '@ionic/vue';

export default {
    name: "novacheck-loading",
    components: { IonSpinner, IonText },
    props: {
        color: {
            type: String,
            default: 'primary'
        }
    }
}
</script>
<style lang="scss" scoped>
.container-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    margin: auto;
    height: 100%;
}

.parent-container {
    height: 100%;
    animation: fadeInAnimation ease 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
}

ion-spinner {
    width: 80px;
    height: 80px;
}

.loading-text {
    font-size: 1.0em;
    font-weight: bold;
}
</style>
